import IntroCard from './IntroCard';

export default IntroCard;